import { MOKA_INVENTORY_API } from '../../constants';

export const DISCOUNTS = `${MOKA_INVENTORY_API}/v2/discounts`;
export const POST_DISCOUNT = `${MOKA_INVENTORY_API}/v1/discounts`;
export const PUT_DISCOUNT = (id) => `${MOKA_INVENTORY_API}/v1/discounts/${id}`;
export const DELETE_DISCOUNT = (id) =>
  `${MOKA_INVENTORY_API}/v1/discounts/${id}`;
export const CREATE_ALL_OUTLET = `${MOKA_INVENTORY_API}/v1/discounts/create_all_outlet`;

export const DISCOUNT_OUTLETS_DETAIL = `${MOKA_INVENTORY_API}/v3/discounts/detail`;
export const GET_DISCOUNT_OUTLETS_LIST = `${MOKA_INVENTORY_API}/v3/discounts`;
export const POST_DISCOUNT_OUTLETS = `${MOKA_INVENTORY_API}/v3/discounts`;
export const PATCH_DISCOUNT_OUTLETS = `${MOKA_INVENTORY_API}/v3/discounts`;
export const DELETE_DISCOUNT_OUTLETS = `${MOKA_INVENTORY_API}/v3/discounts`;
